import { Component, input, model, inject, effect, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormMode } from 'app/core/constants/form-mode';
import { SheetSelectComponent } from 'app/core/components/sheet-select/sheet-select.component';

@Component({
  selector: 'app-third-party-form',
  templateUrl: './third-party-form.component.html',
  styleUrls: ['./third-party-form.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, SheetSelectComponent]
})
export class ThirdPartyFormComponent {
  thirdPartyForm = input<FormGroup>();
  thirdPartyData = input<any>();
  mode = model<FormMode>(FormMode.VIEW);
  brands = input<any[]>();
  allModels = input<any[]>();

  formMode = FormMode;
  filteredModels = signal<any[]>([]);
  isOwnerSameAsDriver = signal<boolean>(false);

  constructor() {
    effect(() => {
      const form = this.thirdPartyForm();
      if (form) {
        this.setupFormListeners(form);
      }
    });
  }

  setupFormListeners(form: FormGroup) {
    const modelsList = this.allModels() ?? [];
    form.get('thirdPartyBrandCode')?.valueChanges.subscribe(() => this.filterModels(form, modelsList));
    form.get('thirdPartyYear')?.valueChanges.subscribe(() => this.filterModels(form, modelsList));
    form.get('thirdPartyDriverName')?.valueChanges.subscribe(v => this.onDriverNameChange(form, v));
    this.initOwnerSameState(form);
  }

  onDriverNameChange(form: FormGroup, val: string) {
    if (this.isOwnerSameAsDriver()) {
      form.get('thirdPartyOwnerName')?.setValue(val, { emitEvent: false });
    }
  }

  initOwnerSameState(form: FormGroup) {
    const driver = form.get('thirdPartyDriverName')?.value;
    const owner = form.get('thirdPartyOwnerName')?.value;
    if (driver && driver === owner) {
      this.isOwnerSameAsDriver.set(true);
      form.get('thirdPartyOwnerName')?.disable();
    }
  }

  toggleOwnerSameAsDriver(value: boolean) {
    this.isOwnerSameAsDriver.set(value);
    const form = this.thirdPartyForm();
    if (!form) return;
    const ownerCtrl = form.get('thirdPartyOwnerName');
    if (value) {
      ownerCtrl?.setValue(form.get('thirdPartyDriverName')?.value);
      ownerCtrl?.disable();
    } else {
      ownerCtrl?.enable();
    }
  }

  // Filtra los modelos según la marca y año elegidos
  filterModels(form: FormGroup, modelsList: any[]) {
    const brand = form.get('thirdPartyBrandCode')?.value;
    const year = form.get('thirdPartyYear')?.value;
    const filtered = modelsList.filter(m => {
      const matchBrand = brand ? m.brandCode === brand : true;
      const matchYear = year ? m.year === year : true;
      return matchBrand && matchYear;
    });
    this.filteredModels.set(filtered);
  }

  // Busca el nombre de la marca por código
  findBrandName(code: number | string): string {
    const b = this.brands()?.find(x => x.code == code);
    return b ? b.name : 'No especificado';
  }

  // Busca el nombre del modelo por código
  findModelName(code: number | string): string {
    const m = this.allModels()?.find(x => x.code == code);
    return m ? m.name : 'No especificado';
  }
}
